type EventPayload = Record<string, string | number | boolean | null>;

export function track(name: string, props?: EventPayload): void {
  if (typeof window === "undefined") return;
  const queue = (window.__analytics = window.__analytics || []);
  queue.push({ name, props, ts: Date.now() });
}

declare global {
  interface Window {
    __analytics?: Array<{ name: string; props?: EventPayload; ts: number }>;
  }
}
